<template>
    <v-dialog v-model="$store.state.Suncor.Drilldown"  persistent>
        <v-card min-height="800px">
            <v-toolbar color="secondary" dark dense>
                <v-toolbar-title>
                    BOL {{ dataRow.BillOfLading }} - {{ dataRow.DeliveryDate }}
                </v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn icon dark @click="$store.state.Suncor.Drilldown = false;"><v-icon>mdi-close</v-icon></v-btn>
            </v-toolbar>

            <v-row>
                <v-container grid-list-xs fluid class="mt-2">
                    <v-data-table :headers="headersUpt" :items="upt" dense>
                        <template slot="body.append">
                                    <tr>
                                        <td colspan="8" class="text-right font-weight-bold">Totals</td>
                                        <td class="font-weight-bold text-left pr-12" style="font-size:14px;">{{ sumColumn(upt, 'Amount').toFixed(2) }}</td>
                                        <td class="font-weight-bold text-left pr-12" style="font-size:14px;">{{ sumColumn(upt, 'SubTotal').toFixed(2) }}</td>
                                        <td class="font-weight-bold text-left pr-12" style="font-size:14px;">{{ sumColumn(upt, 'HSTTax').toFixed(2) }}</td>
                                        <td></td>
                                        <td class="font-weight-bold text-left pr-12" style="font-size:14px;">{{ sumColumn(upt, 'Total').toFixed(2) }}</td>
                                    </tr>
                            </template>
                    </v-data-table>
                </v-container>
            </v-row>

            <v-row>
                <v-container grid-list-xs fluid class="mt-2">
                    <v-data-table :headers="headersSuncor" :items="suncor" dense>
                        <template v-slot:item.TransID="{item}">
                            <v-text-field
                                v-model="item.TransID"
                                dense
                                hide-details
                                @change="updateRowSuncor(item)"
                            ></v-text-field>
                        </template>
                        <template slot="body.append">
                                    <tr>
                                        <td colspan="4" class="text-right font-weight-bold">Totals</td>
                                        <td class="font-weight-bold text-left pr-12" style="font-size:14px;">{{ sumColumn(suncor, 'AmountEffective').toFixed(2) }}</td>
                                        <td class="font-weight-bold text-left pr-12" style="font-size:14px;">{{ sumColumn(suncor, 'TotalAmount').toFixed(2) }}</td>
                                        <td colspan="3"></td>
                                        <td class="font-weight-bold text-left pr-12" style="font-size:14px;">{{ sumColumn(suncor, 'BankAmt').toFixed(2) }}</td>
                                    </tr>
                            </template>
                    </v-data-table>
                </v-container>
            </v-row>
        </v-card>
    </v-dialog>
</template>
<script>
import axios from 'axios';
export default {
    props: ['dataRow'],
    data: function () {
        return {
            headersSuncor: [
                // { text: 'Rec ID', value: 'InvId' },
                // { text: 'InvDate', value: 'InvDate' },
                { text: 'Bill Of Lading', value: 'BOL' },
                { text: 'Date Delivered', value: 'DeliveryDate' },
                { text: 'Material Description', value: 'MaterialDescription' },
                { text: 'Quantity', value: 'ShippedQty' },
                { text: 'Rate', value: 'Rate' },
                { text: 'Amount Effective', value: 'AmountEffective' },
                { text: 'TotalAmount', value: 'TotalAmount' },
                { text: 'Total Value', value: 'TotalValue' },
                { text: 'Surcharge', value: 'Surcharge' },
                { text: 'Tax', value: 'Tax' },
                { text: 'BankAmt', value: 'BankAmt' },
                { text: 'Trans. Upt', value: 'TransID' },
                { text: 'Document', value: 'PaymentDocument' },
                { text: 'FileName', value: 'fileName' },
                { text: 'Clearing', value: 'Clearing' },
            ],
            headersUpt: [
                { text: 'Order #', value: 'OrderID' },
                { text: 'Bill Of Lading', value: 'BillOfLading' },
                { text: 'Date Delivered', value: 'DateDelivered' },
                { text: 'ShiftDetail', value: 'ShiftDetail' },
                { text: 'Quantity', value: 'Quantity' },
                { text: 'Product', value: 'Product' },
                { text: 'TranType', value: 'TranType' },
                { text: 'Rate', value: 'Rate' },
                { text: 'Amount', value: 'Amount' },
                { text: 'SubTotal', value: 'SubTotal' },
                { text: 'HSTTax', value: 'HSTTax' },
                { text: 'HST', value: 'HST' },
                { text: 'Total', value: 'Total' },
                { text: 'InvId', value: 'InvId' },
                { text: 'TranId', value: 'TranId' },
                { text: 'ReconciliationID', value: 'ReconciliationID' },
                { text: 'Reconciliation', value: 'ReconciliationComments' },
            ],
            suncor:[],
            upt:[],
            items: [],
            suncortTotal:[],
        }
    },
    mounted() {
        this.suncorPayMentsWithoutUptData();
    },
    methods: {
        sumColumn(items, key) {
            return items.reduce(
                (acc, item) => acc + parseFloat(item[key]) || 0,
                0
            );
        },
        suncorPayMentsWithoutUptData: function() {
            var str = this.$store;
            str.state.isLoading = true;
            var parms = {
                BOL: this.dataRow.BillOfLading,
                DeliveryDate: this.dataRow.DeliveryDate,
            }
            axios
                .post('conciliation/suncor/analysis', parms,{
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                .then(async response => {
                    // this.Matchs = response.data;
                    this.suncor = response.data['Suncor']; 
                    this.upt = response.data['Upt'];
                    str.state.isLoading = false;
                })
                .catch(function (error) {
                    console.log(error);
                    if (error.response.status === 403) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text:'You do not have the permission to use this function.'
                        });
                    };
                    if (error.response.status === 405) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text:'This file is already uploaded.'
                        });
                                
                    }
                    str.state.isLoading = false;
                });
        },
        updateRowSuncor: function(itm){
            var str = this.$store;
            str.state.isLoading = true;
            var params = {
                TransID: itm.TransID,
                SuncorPmtImpID:itm.SuncorPmtImpID
            };
            axios
                .post('conciliation/suncor/match/tranid', params, {
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                .then(response => {
                    console.log(response.data);
                    str.state.isLoading = false;
                    
                })
                .catch(function (error) {
                    console.log(error);
                    if (error.response.status === 403) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text:
                                'You do not have the permission to use this function.'
                        });
                    }
                });
        }
    }
}
</script>